import PossibleBaseData from './PossibleBaseData';

export default class PossibleParkingType extends PossibleBaseData {
	public constructor() {
		super();
	}
};